export const EVENT_TYPES = [
    'عشاء',
    'عزاء',
    'حفل زواج',
    'حفل تخرج',
    'أعياد',
    'حفل عام',
    'عقائق'
]

export const EVENT_CREATE_REQUEST = 'EVENT_CREATE_REQUEST'
export const EVENT_CREATE_SUCCESS = 'EVENT_CREATE_SUCCESS'
export const EVENT_CREATE_FAIL = 'EVENT_CREATE_FAIL'
export const EVENT_CREATE_CLEAR = 'EVENT_CREATE_CLEAR'

export const EVENT_LIST_REQUEST = 'EVENT_LIST_REQUEST'
export const EVENT_LIST_SUCCESS = 'EVENT_LIST_SUCCESS'
export const EVENT_LIST_FAIL = 'EVENT_LIST_FAIL'

export const EVENT_UNREAD_COUNT_REQUEST = 'EVENT_UNREAD_COUNT_REQUEST'
export const EVENT_UNREAD_COUNT_SUCCESS = 'EVENT_UNREAD_COUNT_SUCCESS'
export const EVENT_UNREAD_COUNT_FAIL = 'EVENT_UNREAD_COUNT_FAIL'

export const EVENT_MARK_READ_SUCCESS = 'EVENT_MARK_READ_SUCCESS'

export const EVENT_DELETE_REQUEST = 'EVENT_DELETE_REQUEST'
export const EVENT_DELETE_SUCCESS = 'EVENT_DELETE_SUCCESS'
export const EVENT_DELETE_FAIL = 'EVENT_DELETE_FAIL'
export const EVENT_DELETE_CLEAR = 'EVENT_DELETE_CLEAR'
